<template>
  <svg
    fill="currentColor"
    height="48"
    viewBox="0 0 32 32"
    width="48"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="focus-visible:border-action-default-hi-focus focus-visible:outline-default-hi"
      :d
    />
  </svg>
</template>

<script setup lang="ts">
import { computed } from 'vue'

export type StarStyle = 'outlined' | 'filled'

const { style = 'outlined' } = defineProps<{
  style?: StarStyle
}>()

const d = computed(() => {
  return style === 'outlined'
    ? 'M27.16,11.86l-6.94-.56L17.54,4.87h0a1.67,1.67,0,0,0-3.08,0L11.78,11.3l-6.94.56a1.67,1.67,0,0,0-.95,2.93l5.29,4.53L7.56,26.1a1.66,1.66,0,0,0,2.49,1.81L16,24.28,22,27.91a1.66,1.66,0,0,0,2.49-1.81l-1.62-6.78,5.29-4.53A1.67,1.67,0,0,0,27.16,11.86Zm0,1.79-5.29,4.53-.7.6.21.89L23,26.45a.14.14,0,0,1,0,.13.21.21,0,0,1-.14.08.17.17,0,0,1-.09,0L16.78,23,16,22.52l-.78.48-6,3.63a.13.13,0,0,1-.09,0A.21.21,0,0,1,9,26.58a.14.14,0,0,1,0-.13l1.62-6.78.21-.89-.7-.6L4.86,13.65a.15.15,0,0,1-.05-.18A.15.15,0,0,1,5,13.36l6.94-.56.92-.07.35-.85,2.68-6.44a.14.14,0,0,1,.15-.1.14.14,0,0,1,.14.08v0l2.68,6.44.35.84.92.08,6.94.56a.14.14,0,0,1,.15.11A.15.15,0,0,1,27.14,13.65Z'
    : 'M27.16,11.86l-6.94-.56L17.54,4.87h0a1.67,1.67,0,0,0-3.08,0L11.78,11.3l-6.94.56a1.67,1.67,0,0,0-.95,2.93l5.29,4.53L7.56,26.1a1.67,1.67,0,0,0,2.49,1.81L16,24.28,22,27.91a1.67,1.67,0,0,0,2.49-1.81l-1.62-6.78,5.29-4.53A1.67,1.67,0,0,0,27.16,11.86Z'
})
</script>
